import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { Data, Variables } from './types'

export const UPDATE_DOMAIN_SUPPLY_CHAINS: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation updateDomainSupplyChains($input: BulkUpdateDomainSupplyChainsInput!) {
    bulkUpdateDomainSupplyChains(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
